export default {
  notification: {
    success: {
      disableSharing: 'O compartilhamento do dashboard foi desabilitado com sucesso.',
    },
  },
  label: {
    title: {
      addChart: 'Adicionar componente',
    },
    button: {
      addChart: 'Adicionar',
    },
    chartPerPage: 'Total por página',
    searchCard: 'Buscar componente',
  },
  dataType: {
    listening: 'Dados não-proprietários',
    sac: 'Dados proprietários',
    page: 'Métricas das páginas',
    blip: 'BLIP',
    'sac-listening': 'Proprietários + Não Proprietários',
    custom: 'Personalizados',
    static: 'Complementares',
    'sac-status': 'Smart Care',
    mp: 'MP',
    sc: 'SC',
    contacts: 'Contatos',
    messages: 'Mensagens',
    'active-messages': 'Mensagens ativas',
    'event-track': 'Registro de eventos',
    'human-service': 'Atendimento humano',
  },
};
